import * as React from "react";
import { useTranslation } from "react-i18next";
import { setAppFooterTestId } from "./app-footer.utils";

interface AppFooterProps {
  testId?: string;
}

export function AppFooter({ testId }: AppFooterProps) {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const copyright = React.useMemo(
    () => t("footer.copyright", { year: currentYear }),
    [t, currentYear],
  );

  return (
    <footer
      data-testid={testId ?? setAppFooterTestId("container")}
      className="border-t border-border-subtle bg-surface-1"
    >
      <div className="flex h-12 items-center justify-center px-6">
        <p className="text-center text-sm text-muted-foreground">{copyright}</p>
      </div>
    </footer>
  );
}
